import styled from 'styled-components'

export const Container = styled.main`
  margin: auto 0;

  a {
    margin-top: 5rem;
  }
`
